import {Component, computed, inject, input} from '@angular/core';
import {Select} from 'primeng/select';
import {NgOptimizedImage} from '@angular/common';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Local} from './models/local';
import {FloatLabel} from 'primeng/floatlabel';
import {MessageModule} from 'primeng/message';


@Component({
  selector: 'elcia-local-dropdown',
  imports: [
    Select,
    NgOptimizedImage,
    ReactiveFormsModule,
    TranslatePipe,
    FloatLabel,
    MessageModule,
  ],
  templateUrl: './local-dropdown.html',
  styleUrl: './local-dropdown.scss',
})
export class LocalDropdown {
  private readonly translateService = inject(TranslateService);

  readonly control = input<FormControl<string | null>>();

  private readonly defaultControl = new FormControl<string | null>(
    localStorage.getItem('lang') ?? 'fr-BE'
  );

  protected readonly activeControl = computed(() => this.control() ?? this.defaultControl);

  protected readonly isRequired = computed(() => this.activeControl().hasValidator(Validators.required));

  protected readonly languages: Local[] = [
    {code: 'en-UK', name: 'English', flagUrl: 'images/countries/en.png'},
    {code: 'fr-BE', name: 'Français', flagUrl: 'images/countries/fr.png'},
    {code: 'nl-BE', name: 'Nederlands', flagUrl: 'images/countries/nl.png'}
  ];

  protected onLanguageChange(event: { value: string }) {
    if (this.control()) {
      return;
    }
    localStorage.setItem('lang', event.value);
    this.translateService.use(event.value);
  }
}
